module.exports = __webpack_public_path__ + "img/103.5966b75b.jpg";